var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "confirm-modal",
    {
      ref: "modal",
      attrs: { confirm: "Удалить", reset: "Отменить", mode: "danger" },
      on: { confirm: _vm.confirm },
    },
    [
      _c("span", [
        _vm._v(
          " Подтвердите удаление " +
            _vm._s(_vm.category === "sick" ? "больничного" : "отпуска") +
            " сотрудника "
        ),
        _c("b", [_vm._v(_vm._s(_vm.worker))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }